import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";

import "@qpokychuk/sf-pro-display/index.css";
import "@qpokychuk/sf-pro-display/normal.css";
import "@qpokychuk/sf-pro-display/italic.css";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { YMInitializer } from 'react-yandex-metrika'

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <YMInitializer
      accounts={[104785852]}
      options={{ webvisor: true, trackLinks: true, accurateTrackBounce: true }}
      version="2"
    />
    <App />
  </Provider>
);
